import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP6ChurnedOvw202602: FaireAdPerformancePeriodEntity = {
  token: "perf_p6_churned_ovw_202602",
  type: "adPerformancePeriod",
  scope: "OVERVIEW",
  periodType: "RECEIPT",
  startDate: "2026-02-01",
  endDate: "2026-02-28",
  impressions: 40898,
  clicks: 778,
  adsSpendDollars: 2057,
  budgetDollars: 2500,
  salesDollars: 10778,
  bestEstimateRoas: 5.24,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.82,
  newCustomersAcquired: 16,
  reorderConversions: 5,
  dataAvailableAtDate: "2026-03-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
